
import { Vue, Component } from "vue-property-decorator";
import NiceButton from "@/components/UI/NiceButton.vue";

@Component({
  components: { NiceButton }
})
export default class InlineAiNoApiKey extends Vue {
  get wpAdminSettingsAiTabUrl() {
    return (
      "wp-admin/admin.php?page=" +
      this.$bdox("admin_page_settings_slug") +
      "&tab=ai"
    );
  }
}
